import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomModal from "../CustomModal";
import "../AssignSymbols/assignSymbols.scss";
import AccordionClaim from "./AccordionClaim";
import { updatSlideData, getAllScripts } from "../../services/apis";
import {
  mergeRelatedSymbolForAllParentsInModule,
  normRelatedId,
  syncCanvasRelatedSymbolsForSharedClaim,
} from "../../utils/editorUtils/claimEditorUsage";

const AssignsymbolPopup = ({
  OpenAssignPopup,
  setOpenAssignPopup,
  setAppledSymbol,
  footnoteSymbols,
  symbolAssigned,
  cancelPopup,
  claim,
  item,
  moduleClaimsData,
  relatedClaimsData,
  setRelatedClaimsData,
  setPreviewLoading,
  setSymbolsObjData,
  symbolsObjData,
  setAssignedSymbols,
  editor,
  appliedSymbol,
  previewLoading,
}) => {
  const relatedSliceKey = normRelatedId(
    item?.claimName || item?.reusableTextName || "",
  );
  const parentClaimId = normRelatedId(
    claim?.claimName || claim?.componentDocNumber || "",
  );
  const [clickedSymbols, setClickedSymbols] = useState(null);
  const [updateList, setUpdateList] = useState(false);
  const { pageId } = useParams();
  useEffect(() => {
    getAllScripts(pageId, (response, err, errorCode) => {
      setPreviewLoading(true);
      if (err) {
        setPreviewLoading(false);
        // setIsloading(false);
      } else {
        // setIsloading(false);
        const selectedRelatedClaims = response?.data?.relatedClaimsData;
        setRelatedClaimsData([...selectedRelatedClaims]);
        setPreviewLoading(false);
      }
    });
  }, [OpenAssignPopup]);

  useLayoutEffect(() => {
    if (!previewLoading && relatedClaimsData) {
      // Runs after DOM updates but BEFORE painting
      setUpdateList(true);
    }
  }, [previewLoading, relatedClaimsData]);
  const selectSymbol = (icons) => {
    const modId = normRelatedId(moduleClaimsData?.moduleDamName);
    if (Array.isArray(relatedClaimsData) && modId && relatedSliceKey) {
      for (let i = 0; i < relatedClaimsData.length; i++) {
        const row = relatedClaimsData[i];
        if (
          normRelatedId(row.relatedClaimId) === relatedSliceKey &&
          normRelatedId(row.moduleId) === modId
        ) {
          relatedClaimsData[i] = { ...row, symbol: icons, text: "" };
        }
      }
    }
    setClickedSymbols(icons);
  };

  const assignSymbolsHandler = (symbol) => {
    setPreviewLoading(true);
    const moduleId = normRelatedId(moduleClaimsData?.moduleDamName);
    const currentParent = parentClaimId || normRelatedId(claim.claimName);
    const merged = mergeRelatedSymbolForAllParentsInModule(
      relatedClaimsData,
      moduleId,
      relatedSliceKey,
      symbol,
      moduleClaimsData,
      currentParent,
    );
    setRelatedClaimsData(merged);
    setAssignedSymbols?.(merged);
    setAppledSymbol(symbol);
    syncCanvasRelatedSymbolsForSharedClaim(
      editor,
      relatedSliceKey,
      symbol,
      moduleClaimsData,
      currentParent,
    );
    finalAssignment(merged);
  };

  const finalAssignment = (payObj) => {
    const payLoad = {
      relatedClaimsData: payObj,
    };
    // console.log("finllllllllllllllllllllllllll", pageId, payLoad);
    updatSlideData(pageId, payLoad, (response, err, errorCode) => {
      if (err) {
        setPreviewLoading(false);
      } else {
        // setIsloading(false);
        // console.log("====res", response);
        const next = response.data.relatedClaimsData;
        setRelatedClaimsData(next);
        setAssignedSymbols?.(next);
        setOpenAssignPopup(false);
        setPreviewLoading(false);
      }
    });
  };

  const closePopup = () => {
    setPreviewLoading(true);
    const modIdClose = normRelatedId(moduleClaimsData?.moduleDamName);
    if (Array.isArray(relatedClaimsData) && modIdClose && relatedSliceKey) {
      for (let i = 0; i < relatedClaimsData.length; i++) {
        const row = relatedClaimsData[i];
        if (
          normRelatedId(row.relatedClaimId) === relatedSliceKey &&
          normRelatedId(row.moduleId) === modIdClose
        ) {
          relatedClaimsData[i] = {
            ...row,
            symbol: appliedSymbol,
            text: row.text ?? "",
          };
        }
      }
    }
    cancelPopup(appliedSymbol);
    setPreviewLoading(false);
    /* if (clickedSymbols !== null) {
      // finalAssignment([...relatedClaimsData]);
    } else {
      cancelPopup(appliedSymbol)
      setPreviewLoading(false);
    } */

    /* setRelatedClaimsData([...relatedClaimsData])  
    cancelPopup(appliedSymbol) */
  };
  return (
    <div className="assign-container">
      <div className="head-content">
        <div className="head-msg">
          <div className="head-css">ASSIGN CLAIM SYMBOL</div>
        </div>
      </div>
      <div className="actual-content d-flex">
        {/*   <div className="claims-section">                    
                </div>
                <div className="claims-content"></div>
                <div className="symbols"></div> */}
        {updateList &&
          !previewLoading &&
          footnoteSymbols.map((icons, index) => (
            <div
              className={`icons-css ${
                icons === clickedSymbols ? "clicked-symbols" : ""
              } ${
                relatedClaimsData.findIndex(
                  (data) =>
                    data.symbol === icons && data.symbol !== clickedSymbols
                ) > -1
                  ? "not-allowed-icon"
                  : ""
              }`}
              onClick={(e) => {
                selectSymbol(icons);
                // assignSymbolsHandler(icons);
              }}
              disabled={
                relatedClaimsData.findIndex(
                  (data) =>
                    data.symbol === icons && data.symbol !== clickedSymbols
                ) > -1
                  ? "true"
                  : "false"
              }
              style={{
                paddingTop:
                  index === 15 || index === 16
                    ? "14px"
                    : index === 31
                    ? "7px"
                    : index === 1
                    ? "8px"
                    : index === 0
                    ? "24px"
                    : "0px",
                fontSize:
                  icons === "***" || icons === "**"
                    ? "28px"
                    : icons === "†"
                    ? "40px"
                    : icons === "*"
                    ? "52px"
                    : "28px",
                fontWeight:
                  icons === "△" ||
                  icons === "~" ||
                  icons === "ǂ" ||
                  icons === "£"
                    ? "700"
                    : "500",
                letterSpacing: icons === "∥∥" && "-1.9px",
                fontFamily: [
                  "I",
                  "II",
                  "III",
                  "IV",
                  "V",
                  "VI",
                  "VII",
                  "VIII",
                  "IX",
                  "X",
                ].includes(icons)
                  ? `"Times New Roman', serif"`
                  : `"Nunito Sans", sans-serif`,
              }}
            >
              {icons}
            </div>
          ))}
      </div>
      <div className="foot-content">
        {/* <div className="shadow-line"></div> */}
        <div className="btn-section">
          <div>
            <button
              className="cancel-btn"
              onClick={() => closePopup(clickedSymbols)}
            >
              CANCEL
            </button>{" "}
            {/* class="details-informations-close" */}
          </div>
          <div>
            <button
              className={`assign-btn ${
                clickedSymbols !== null ? "active-assign" : ""
              }`}
              onClick={() => {
                assignSymbolsHandler(clickedSymbols);
              }}
              disabled={clickedSymbols !== null ? false : true}
            >
              ASSIGN
            </button>{" "}
            {/* disabled="" class="details-informations-update" */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignsymbolPopup;
